import { createUseStyles } from 'react-jss';
import { base } from '../../css/vars';

export default createUseStyles({
  insertFinishes: {
    '& > *:not(:last-child)': {
      marginBottom: base(),
    },
  },
});
